'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@awesome.me/kit-94e593bf23/icons/sharp/regular'

import { useCallback, useMemo, useRef } from 'react'

const QuantityInput = ({quantity, setQuantity, className, input_padding = 'py-1', maxQuantity, size = 'md'}) => {

    const handleInputChange = (event) => {
        const value = event.target.value

        // Allow empty string for user to clear and retype
        if (value === '') {
            setQuantity('')
            return
        }

        const qty = parseInt(value)
        if (isNaN(qty) || qty < 1) return
        if (maxQuantity && qty > maxQuantity) return
        setQuantity(qty)
    }

    const handleBlur = () => {
        // Ensure valid value when user leaves input
        if (quantity === '' || isNaN(parseInt(quantity))) {
            setQuantity(1)
        }
    }

    const incrementQty = () => {
        const currentQty = parseInt(quantity)
        if (isNaN(currentQty)) return
        if (maxQuantity && currentQty >= maxQuantity) return
        setQuantity(currentQty + 1)
    }

    const decrementQty = () => {
        const currentQty = parseInt(quantity)
        if (isNaN(currentQty) || currentQty <= 1) return
        setQuantity(currentQty - 1)
    }

    const sizes = {
        sm: 'min-w-20 max-w-24',
        md: 'min-w-28 max-w-32'
    }

    const currentQty = parseInt(quantity)
    const isMinQty = isNaN(currentQty) || currentQty <= 1
    const isMaxQty = maxQuantity && currentQty >= maxQuantity

    return (
        <div className={`flex items-center px-.5 border border-gray-10 rounded ${sizes[size]} ${className ? className : ''}`} role="group" aria-label="Quantity selector">
            <button
                onClick={decrementQty}
                aria-label="Decrease quantity"
                disabled={isMinQty}
                className={`p-2 px-3 text-center text-2xs duration-200 transition-all ${isMinQty ? 'text-light cursor-not-allowed' : 'text-light hover:text-primary'}`}
            >
                <FontAwesomeIcon icon={faMinus} aria-hidden="true" />
            </button>
            <input
                className={`text-center text-md m-0 px-2 w-full [&::-webkit-inner-spin-button]:appearance-none focus:outline-none focus:ring-1 focus:ring-primary ${input_padding}`}
                type="number"
                name="quantity"
                value={quantity}
                onChange={handleInputChange}
                onBlur={handleBlur}
                aria-label="Quantity"
                min="1"
                max={maxQuantity || undefined}
            />
            <button
                onClick={incrementQty}
                aria-label="Increase quantity"
                disabled={isMaxQty}
                className={`p-2 px-3 text-center text-2xs duration-200 transition-all ${isMaxQty ? 'text-light cursor-not-allowed' : 'text-light hover:text-primary'}`}
            >
                <FontAwesomeIcon icon={faPlus} aria-hidden="true" />
            </button>
        </div>
    )
}

export default QuantityInput
